// extracted by mini-css-extract-plugin
export var barContainer = "_u-0";
export var extraThin = "_u-3";
export var fillBar = "_u-6";
export var fillContainer = "_u-4";
export var overflow = "_u-8";
export var overflowContainer = "_u-5";
export var regular = "_u-7";
export var thick = "_u-1";
export var thin = "_u-2";